import { format, parseISO } from "date-fns";

export const operators = [
  {value: 'between', label: 'between'},
  {value: '=', label: 'on'},
  {value: '<', label: 'before'},
  {value: '>', label: 'after'},
  {value: 'isNull', label: 'no value'},
];

const formatDate = str => format(parseISO(str), 'MM/dd/yyyy');

export function getFormattedValue(field, filter) {
  switch (filter.operator) {
    case 'between':
      return `${formatDate(filter.value)} – ${formatDate(filter.valueTwo)}`;
    case '<':
      return `before ${formatDate(filter.value)}`;
    case '>':
      return `after ${formatDate(filter.value)}`;
    case '=':
      return `${formatDate(filter.value)}`;
    case 'isNull':
      return 'empty';
  }
}

export function isValid(filter) {
  switch (filter.operator) {
    case 'isNull':
      return true;
    case '<':
    case '>':
    case '=':
      return filter.value.length > 0;
    case 'between':
      return filter.value.length > 0
        && filter.valueTwo.length > 0
        && filter.value < filter.valueTwo;
  }
}

export function getApiParam(field, filter) {
  switch (filter.operator) {
    case null:
    case '=':
      // Look for anything on that day
      return `between(${filter.value} 00:00:00|${filter.valueTwo} 23:59:59)`;
    case 'between':
      return `between(${filter.value}|${filter.valueTwo})`;
    case '<':
      return `before(${filter.value})`;
    case '>':
      return `after(${filter.value})`;
    case 'isNull':
      return 'is(null)';
  }

}
